/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constructor fantasy price`)
};

const es_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precio fantasy del constructor`)
};

const de_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konstrukteur-Fantasy-Preis`)
};

const nl_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Constructeur fantasy-prijs`)
};

const fr_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prix fantasy du constructeur`)
};

const it_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezzo fantasy costruttore`)
};

const pt_br2_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço fantasy do construtor`)
};

const pt_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preço fantasy do construtor`)
};

const ja_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コンストラクターファンタジー価格`)
};

const zh_f1_profile_tooltip_constructor_price = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`车队梦幻价格`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_constructor_price = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_constructor_price(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_constructor_price", locale)
	if (locale === "en") return en_f1_profile_tooltip_constructor_price(inputs)
	if (locale === "es") return es_f1_profile_tooltip_constructor_price(inputs)
	if (locale === "de") return de_f1_profile_tooltip_constructor_price(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_constructor_price(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_constructor_price(inputs)
	if (locale === "it") return it_f1_profile_tooltip_constructor_price(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_constructor_price(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_constructor_price(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_constructor_price(inputs)
	return zh_f1_profile_tooltip_constructor_price(inputs)
};